import { render, staticRenderFns } from "./CompanySelector.vue?vue&type=template&id=6801992e&scoped=true&"
import script from "./CompanySelector.vue?vue&type=script&lang=js&"
export * from "./CompanySelector.vue?vue&type=script&lang=js&"
import style0 from "./CompanySelector.vue?vue&type=style&index=0&id=6801992e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6801992e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6801992e')) {
      api.createRecord('6801992e', component.options)
    } else {
      api.reload('6801992e', component.options)
    }
    module.hot.accept("./CompanySelector.vue?vue&type=template&id=6801992e&scoped=true&", function () {
      api.rerender('6801992e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/CompanySelector.vue"
export default component.exports